import React, { useState } from "react";
import { Button } from "components";

import "./index.scss";

const randomCoupon = require('random-letters');

const KeysIcon = () => <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 8.33073C10 8.77276 10.1756 9.19668 10.4882 9.50924C10.8007 9.8218 11.2246 9.9974 11.6667 9.9974C12.1087 9.9974 12.5326 9.8218 12.8452 9.50924C13.1577 9.19668 13.3333 8.77276 13.3333 8.33073C13.3333 7.8887 13.1577 7.46478 12.8452 7.15222C12.5326 6.83966 12.1087 6.66406 11.6667 6.66406C11.2246 6.66406 10.8007 6.83966 10.4882 7.15222C10.1756 7.46478 10 7.8887 10 8.33073Z" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M17.5 10C17.5 10.9849 17.306 11.9602 16.9291 12.8701C16.5522 13.7801 15.9997 14.6069 15.3033 15.3033C14.6069 15.9997 13.7801 16.5522 12.8701 16.9291C11.9602 17.306 10.9849 17.5 10 17.5C9.01509 17.5 8.03982 17.306 7.12987 16.9291C6.21993 16.5522 5.39314 15.9997 4.6967 15.3033C4.00026 14.6069 3.44781 13.7801 3.0709 12.8701C2.69399 11.9602 2.5 10.9849 2.5 10C2.5 8.01088 3.29018 6.10322 4.6967 4.6967C6.10322 3.29018 8.01088 2.5 10 2.5C11.9891 2.5 13.8968 3.29018 15.3033 4.6967C16.7098 6.10322 17.5 8.01088 17.5 10Z" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10.4166 9.58594L7.08325 12.9193L8.33325 14.1693" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 12.5L8.75 11.25" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>;




export default ({ form, setDelimiter, isVariant, setVariant }) => {

    const [showForm, setForm] = useState(false);
    const [prefix, setPrefix] = useState("");
    const [quantity, setQuantity] = useState(10);

    const handleGenerate = () => {

        let serials = [];

        for (let i = 0; i < quantity; i++) {
            serials.push((`${prefix}-${randomCoupon(16)}`).toUpperCase());
        }

        setDelimiter("comma");
        form.setFieldValue("stock_delimiter", "comma");
        if(isVariant) {
            setVariant(serials.join(","));
        } else {
            form.setFieldValue("serials", serials.join(","));
        }
    }

    return (
        <div className={`generate-serials-container ${isVariant ? 'is-variant' : ''}`}>

            <label className={`generate-serials-header ${showForm ? 'open' : ''}`} htmlFor="generate">

                <span>
                    <span><KeysIcon />&nbsp;&nbsp;&nbsp;Generate Serials</span>

                    <div className="switcher-container">
                        <label className="switcher mr-0">
                            <input type="checkbox" id="generate" name="update" checked={showForm} onChange={(e) => {
                                setForm(e.target.checked);
                            }}/>
                            <span className="switcher-slider"/>
                        </label>
                    </div>
                </span>


                {
                    showForm ?
                        <div className="generate-serials-text">
                            Let us generate the serials for you. We will issue a defined number of random strings that can be sold to your customers directly.
                        </div>
                    : null
                }
            </label>

            {
                showForm ?
                    <div className="generate-serials-body">
                        <div className="w-100 d-flex">
                            <div className="w-70 mr-3">
                                <label htmlFor="" className="paylixecommerce-label">Serial Prefix</label>
                                <input className="paylixecommerce-input" placeholder="SLX" type="text" value={prefix} onChange={(e) => setPrefix(e.target.value)} />
                            </div>
                            <div className="w-30">
                                <label htmlFor="" className="paylixecommerce-label">Serials Qty</label>
                                <input className="paylixecommerce-input" type="number" value={quantity} onChange={(e) => setQuantity(e.target.value)} />
                            </div>
                        </div>
                        <Button disabled={quantity < 0 || prefix === ""} variant="primary" size="large" className="mt-3" onClick={() => handleGenerate()}>Generate Serials</Button>
                    </div>
                : null
            }
        </div>
    )
}